export default __webpack_public_path__ + "static/media/sdr_calculator_preview.34de61fb.png";